import { EGetFlatStatsActionType } from '../../actions/flatStats';
import { EFlatStatsStatus, TFlatStatsState } from '../../types/flatStats';
import { TReduxActions } from '../../types/redux';

const defaultState: TFlatStatsState = {
  status: EFlatStatsStatus.Initial,
  result: null,
  errorMessage: '',
};

export function flatStatsReducer(state: TFlatStatsState = defaultState, action: TReduxActions): TFlatStatsState {
  switch (action.type) {
    case EGetFlatStatsActionType.Succeed:
      return {
        ...state,
        status: EFlatStatsStatus.Succeed,
        result: action.payload.items,
        errorMessage: '',
      };
    case EGetFlatStatsActionType.Failed:
      return {
        ...state,
        status: EFlatStatsStatus.Failed,
        result: null,
        errorMessage: action.payload,
      };
    case EGetFlatStatsActionType.Loading:
      return {
        ...state,
        status: EFlatStatsStatus.Loading,
        result: null,
        errorMessage: '',
      };
  }

  return state;
}
